module.exports = __webpack_public_path__ + "img/5-5.6e15c671.png";